import React, { Component } from 'react';
import moment from 'moment';
import cx from 'classnames';
import _ from "lodash";
import ScheduleDetails from './ScheduleDetails';
import './index.scss';

const no_of_days = 7;

function create_UUID(){
    var dt = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (dt + Math.random()*16)%16 | 0;
        dt = Math.floor(dt/16);
        return (c=='x' ? r :(r&0x3|0x8)).toString(16);
    });
    return uuid;
}

class TimeSlot extends Component{
    constructor(props){
        super(props);
        this.state = {
            initDate:new Date(),
            no_of_days:7,
            header:this.getHeaderDays(new Date(),7),
            loading:true,
            availability:[],
            schedule: {
                appointments: [],
                staff_schedule: []
            },
            parsedAvailability:[],
            selected_service:'',
            selected_staff:'',
            selected_resource:'',
            selectedSchedule:{},
            showDetails:false
        };
    }

    componentDidMount(){        
        this.fetchAvailability({
            start_date : moment().format('YYYY-MM-DD'),
            start_time:moment().format('HH:mm:ss'), 
            end_date : moment().add(no_of_days,'days').format('YYYY-MM-DD'), 
            end_time:"23:59:59" 
        });
    }

    componentWillReceiveProps(nextProps){
        if(nextProps?.schedules?.availability!== this.props?.schedules?.availability){
            this.setState({
                availability : nextProps?.schedules?.availability,
                schedule: nextProps?.schedules?.schedule,
            })
        }
    }
    
    componentDidUpdate(prevProps, prevState) {
        if(this.state.availability != prevState.availability) {
            this.getDateRangeArray();
        }
        if(prevProps.selected_service !== this.props.selected_service 
            || prevProps.selected_staff !== this.props.selected_staff 
            || prevProps.selected_resource !== this.props.selected_resource
        ){
            this.onFilterUpdate();
        }
    }
    
    onFilterUpdate=()=>{
        const { initDate } = this.state;
        this.fetchAvailability({
            start_date : moment(initDate).format('YYYY-MM-DD'),
            start_time:moment().format('HH:mm:ss'), 
            end_date : moment(initDate).add(no_of_days,'days').format('YYYY-MM-DD'), 
            end_time:"23:59:59" 
        });
    }

    getHeaderDays = (date,no_of_days) =>{
        let headerDays= [],i;
        for(i=0;i<no_of_days;i++){
            headerDays.push(moment(date).add(i,'days').startOf('day'));
        } 
    return headerDays;
    }

    getDateRangeArray = () =>{
        const { schedule } = this.state;
        const { business_working_hours } = this.props;
        const blockedSlot = schedule?.staff_schedule?.filter(slot=>!slot.isAvailable);
        const parsedblockedSlot = blockedSlot.map(slot=>{ 
            const data = { ...slot, times:{ date:slot.date , slot:{...slot.slots[0] }}}
            return data;
            });
        const result = schedule?.appointments.concat(parsedblockedSlot);
        console.log('SLOT LOG 1',parsedblockedSlot, blockedSlot);
        let daterange1 = [];
        for(let j=0;j<result.length;j++){
            
                const { date, slot } = result[j]?.times;
               const {start, end} = slot;
               const isAvailable = !(result[j]?.isAvailable === false);
               const datetime = date+''+start; 
                let diff = moment.duration(moment(end,'HH:mm:ss').diff(moment(start,'HH:mm:ss'))).asMinutes();
                console.log('SLOT LOG 1',start, end, diff);
                 if(moment(start,'HH:mm:ss').hour()!==moment(end,'HH:mm:ss').hour()){
                     let time_start = start;
                     let title_display = true;
                     do{
                         let time_diff =  diff > 59 ? 60 - moment(time_start,'HH:mm:ss').minutes(): diff;
                         let range = { slotdata: result[j],time_diff ,...(!!isAvailable && {title: result[j]?.sections[0]?.user_name}), title_display ,blocked:!isAvailable ,start:time_start, end: moment(time_start,'HH:mm:ss').add(time_diff-1,'minutes').format('HH:mm:ss'),date:date, id: create_UUID() , slotid: moment(datetime,'YYYY-MM-DD HH:mm:ss').valueOf()}
                         time_start = moment(range.end,'HH:mm:ss').add(1,'minutes').format('HH:mm:ss');
                         daterange1.push(range);
                         diff = diff - time_diff;
                         title_display = false;
                     }while(diff>0)
                 }else{
                     let range = { slotdata: result[j], time_diff:diff, ...(!!isAvailable && {title: result[j]?.sections[0]?.user_name}),title_display:true, blocked:!isAvailable, start:start, end: end,date:date, id: create_UUID() , slotid: moment(datetime,'YYYY-MM-DD HH:mm:ss').valueOf()}
                     daterange1.push(range);
                 }
            
        }
        console.log('SLOT LOG 2', business_working_hours, daterange1, daterange1.filter(slot=>slot.blocked));

        daterange1 = _.uniqBy(daterange1, 'id');
        let headerDays = this.getHeaderDays(moment(this.state.initDate,'YYYY-MM-DD'),no_of_days);
        let slotSchedule =[]
        for(let i=0;i<business_working_hours.length;i++){
            slotSchedule[i] =[];
            for(let j=0;j<headerDays.length;j++){
                slotSchedule[i][j] = daterange1.filter(slot=>moment(slot.date,'YYYY-MM-DD').isSame(headerDays[j]) && moment(slot.start,'HH:mm:ss').isBetween(moment(business_working_hours[i].start,'HH:mm:ss'),moment(business_working_hours[i].end,'HH:mm:ss')));
            }
        }
        console.log('twoDarray',slotSchedule);
        
        let groupedResults = _.groupBy(daterange1, (result) => moment(result['date'], 'YYYY-MM-DD').startOf('isoDay'));
              
        let slot = sessionStorage.getItem('slot');
        const { initDate } = this.state;
        let initialDate = initDate;
        let first_result = (Object.keys(groupedResults)[0])?new Date(Object.keys(groupedResults)[0]):initDate;
        if(moment(first_result).diff(initDate,'days')>no_of_days-1){
            initialDate = new Date(Object.keys(groupedResults)[0]);
        }
  
        this.setState({
            header:Object.keys(groupedResults).slice(0, no_of_days),
            loading:false,
            initDate: initialDate,
            parsedAvailability: slotSchedule
        })
    }

    fetchAvailability =(time_span)=>{
        const { business, selected_service, selected_staff, selected_resource,location_id } = this.props;
        let requestData = {};
        requestData.business_id = business.id;
        requestData.service_id = selected_service;
        requestData.staff_ids = typeof selected_staff === "object"? selected_staff:[selected_staff];
        requestData.location_id = location_id;
        requestData.resource_ids= typeof selected_resource === "object"? selected_resource:[selected_resource];
        requestData.time_span = time_span;
        this.setState({initDate: time_span.start_date, loading:true});
        this.props.getDentalBooking(requestData);
    }

    loadNext = () =>{
        const header  = this.validateHeader(this.state.header);
        this.fetchAvailability({
            start_date : moment(header[header.length-1]).add(1,'days').format('YYYY-MM-DD'),
            start_time:"00:00:00", 
            end_date : moment(header[header.length-1]).add(no_of_days+2,'days').format('YYYY-MM-DD'), 
            end_time:"23:59:59" 
        });
    }

    loadPrev = () =>{
        const header  = this.validateHeader(this.state.header);
        let start = moment().isBefore(header[0])?moment(header[0]):moment();
        this.fetchAvailability(
            {
            start_date: start.subtract(no_of_days,'days').format('YYYY-MM-DD'), 
            start_time: moment().isBefore(start.subtract(no_of_days,'days'))?'00:00:00':moment().format('HH:mm:ss'),
            end_date: moment(header[0]).format('YYYY-MM-DD'),
            end_time:"23:59:59", 
        });
    }
    jumpToToday = () =>{
        this.fetchAvailability({
            start_date : moment().format('YYYY-MM-DD'),
            start_time:"00:00:00", 
            end_date : moment().add(no_of_days+2,'days').format('YYYY-MM-DD'), 
            end_time:"23:59:59" 
        });
    }
    validateHeader=(header)=>{
        const { initDate } = this.state;
        let headerDays = this.getHeaderDays(moment(initDate,'YYYY-MM-DD'),no_of_days);
        return headerDays.slice(0, no_of_days);
    }
    getBlockHeight=(diff)=>{
        return Math.round((diff/60)*100).toString()+'%';
    }
    selectSchedule=(schedule)=>{
        console.log('schedule',schedule)
        this.setState({
            selectedSchedule:schedule,
            showDetails:true
        })
    }
    handlePaneClose=()=>{
        this.setState({
            selectedSchedule:{},
            showDetails:false
        })
    }
    getAlignment=(time)=>{
        const minute = moment(time,'HH:mm:ss').minutes();
        if(minute>29){
            return 'flex-end';
        }else{
            return 'flex-start';
        }
    }
    getBlockWidth=(slotofDay)=>{
        const width = 100/slotofDay.length+'%';
        console.log("WIDTH",slotofDay, width.toString());
        return width.toString();
    }
    render(){
        const {header,loading, parsedAvailability, selectedSchedule, showDetails} = this.state;
        const { auth, business, getNameFromId} = this.props;
        const displayheader = this.validateHeader(header);
        return(<>
            <div className="scheduleslot">
            <table className={cx('slot-table', {'loading': loading})}>
            {loading && <div className="loader"></div>}
                <thead className="slot-header" >
                    <tr className="header-row">
                    <th>
                    <button className={cx('slot-header__header',{'disabled': moment().startOf('day').isSame(displayheader[0])} )} onClick={this.loadPrev} disabled={moment().startOf('day').isSame(displayheader[0])}>
                        <div><i className="material-icons">chevron_left</i></div>
                    </button>
                    </th>
                        {displayheader && displayheader.map((date,index)=>{
                        return<th key={date} className={`header-${index}`}>
                                <div className="slot-header__header">
                                    {moment().startOf('day').diff(moment(date).startOf('day'),'days')===0 &&<div className="dot">.</div>}
                                    <div className="day_of_week">   
                                        {moment(date).format('ddd')}
                                    </div>
                                    <div className="day_of_month">   
                                        {moment(date).format('MMM DD')}
                                    </div>
                                </div>
                              </th>
                        })}
                    <th>
                    <button className="slot-header__header" onClick={this.loadNext}>
                        <div><i className="material-icons">chevron_right</i></div>
                    </button>
                    </th>
                        </tr>
                </thead>
               
                <tbody className="slot-body">
                {parsedAvailability.map((slots,index)=>{
                    return (<tr className="slot-body__row">
                         <td className="slot-body__row__data slot-label">
                             <div className="slot-body__row__data_timeslots">{this.props.business_working_hours[index].label}</div>
                         </td>
                        {slots.map((slotofDay,indexI)=>{
                            return (<td className="slot-body__row__data">
                                <div className="slot-body__row__data_period">
                                {slotofDay.map((slot,indexJ)=>{
                                   return <>{slot.blocked?<div style={{ width:this.getBlockWidth(slotofDay), height:this.getBlockHeight(slot.time_diff), paddingRight: '5px',alignSelf:this.getAlignment(slot.start) }}><div  className="blocked" >{slot.title_display? moment(slot.start,'HH:mm:ss').format('hh:mm')+ ' Blocked scheduling': ''}</div></div>:<div style={{ width:this.getBlockWidth(slotofDay) ,height:this.getBlockHeight(slot.time_diff),minHeight:'38px', paddingRight: '5px', alignSelf:this.getAlignment(slot.start)}}><div  className="scheduled" onClick={()=>this.selectSchedule(slot)}>{slot.title_display?moment(slot.start,'HH:mm:ss').format('hh:mm')+' '+slot.title:''}</div></div>}</>
                                })}
                                </div>
                             </td>)
                        })}
                     <td className="slot-body__row__data"></td>
                    </tr>)
                })}
                </tbody>
            </table>
            
            {showDetails? (
            <ScheduleDetails
                selectedSchedule={selectedSchedule}
                visibility={showDetails}
                onClose={this.handlePaneClose}
                auth={auth}
                business={business}
                getClientDetails={this.props.getClientDetails}
                clientsDetails={this.props.clientsDetails}
                conversations={this.props.conversations}
                getNameFromId={getNameFromId}
            />
            ) : null}
            </div>
             </>
        )
    }
}

export default TimeSlot;